
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystacabs() {



    const cardData =
    {
        keyword: 'Innova Crysta Cabs / Taxi Booking in Pune',
        heading: 'Meghana Cab : Innova Crysta Cabs / Taxi Booking in Pune',
        headingDescription: 'Meghana Cab offers Innova Crysta Cabs / Taxi Booking in Pune, providing a premium, spacious, and comfortable ride for every occasion in and around the city. Whether you are planning airport transfers, corporate travel, outstation tours, or family outings, our fleet of Innova Crysta vehicles delivers classy interiors, ample legroom, and generous luggage space. Choose between pay-per-hour, half-day, full-day, or one-way travel packages tailored to your schedule. Enjoy professional chauffeurs, transparent pricing, GPS-enabled tracking, and 24/7 customer support. Book your Innova Crysta Taxi in Pune with Meghana Cab and travel in style, comfort, and reliability—wherever your journey takes you.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

    "topPlaces": [
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in the serene and upscale Koregaon Park area, the Osho International Meditation Resort is one of the world’s most renowned spiritual centers. Spread across 28 acres of lush green landscape, it blends modern luxury with meditative practices. Visitors can participate in dynamic meditation sessions, yoga, Tai Chi, and wellness therapies. The center features marble walkways, Zen gardens, a luxurious guesthouse, and a black marble Buddha Hall. It attracts seekers from across the globe seeking inner peace, detoxification, and spiritual transformation."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched dramatically atop the Sahyadri mountains at an altitude of 1,317 meters, Sinhagad Fort is steeped in Maratha history, particularly the valiant battle fought by Tanaji Malusare in 1670. The rugged uphill trek to the fort rewards adventurers with panoramic views of the Western Ghats and Khadakwasla Dam. Inside, visitors will find remnants of fortifications, memorials to fallen warriors, and age-old bastions. The fort is a weekend favorite, where trekkers enjoy authentic local foods like pithla-bhakri and buttermilk served at small hilltop stalls."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Constructed in 1732, Shaniwar Wada was once the opulent residence of the Peshwas of the Maratha Empire. Although largely destroyed by a fire in 1828, its grand Delhi Gate, fortified walls, lotus-shaped fountains, and expansive courtyards offer a glimpse into 18th-century Maratha grandeur. The site is known for legends of palace intrigue and ghostly folklore. An engaging light-and-sound show held in the evenings narrates its glorious and tragic history, making it a key cultural landmark in Pune’s historic heart."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892 by Sultan Aga Khan III, this grand palace served both as a charitable relief center during famines and later as a pivotal site in India’s independence movement. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here following the Quit India Movement. The Italian arches, manicured gardens, and high-ceilinged halls now house a memorial and museum, displaying Gandhi’s personal belongings, letters, and photographs. The peaceful grounds and historical aura offer a reflective escape from the city’s rush."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved out of a single basalt rock in the 8th century, the Pataleshwar Cave Temple is a monolithic shrine dedicated to Lord Shiva. This hidden heritage gem, located near Jangli Maharaj Road, includes a sanctum with a linga, a circular Nandi mandapa, and intricately carved columns. Despite being located amidst urban sprawl, the site maintains a calm, almost mystical atmosphere. Its historical and architectural significance make it one of the oldest and most unique spiritual landmarks in Pune."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "A spiritual epicenter for Punekars, this temple is dedicated to Lord Ganesha and features a stunning 7.5-foot-tall idol adorned with over 40 kg of gold. Established over 125 years ago by sweet merchant Dagdusheth Halwai, the temple is known for its elaborate Ganesh Chaturthi celebrations that attract lakhs of devotees, celebrities, and political leaders. The temple's gold and silver interiors, 24x7 devotional music, and public service initiatives create a divine yet inclusive atmosphere year-round."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Rising about 2,100 feet above sea level, Parvati Hill offers a spiritual retreat and panoramic views of Pune. A climb of 103 steps leads to a cluster of 18th-century temples built by the Peshwas, most notably the Parvati Temple dedicated to Goddess Parvati and Lord Shiva. A small museum atop the hill showcases Maratha-era artifacts and paintings. The location is ideal for early morning walks, photography, and sunset views—combining religious significance with natural beauty."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This fascinating museum houses over 20,000 historic artifacts meticulously collected by Dr. Dinkar Kelkar, of which 2,500 are on display. From musical instruments and ornate doors to miniature paintings, sculptures, and household items from the 18th and 19th centuries, it offers a vivid portrait of traditional Indian life. The museum’s highlight is the recreated 'Mastani Mahal,' reflecting the grandeur of the Maratha court. Multilingual audio guides, themed galleries, and educational tours enrich the cultural experience."
  },
  {
    "title": "Shinde Chhatri",
    "description": "An elegant memorial dedicated to Mahadji Shinde, a prominent 18th-century Maratha military leader, this structure blends Rajasthani and Anglo-European architectural styles. Located in Wanowrie, it houses beautifully carved spires, intricately patterned stained-glass windows, and a peaceful Shiva temple. The complex, with its quiet courtyards and detailed murals, stands as a solemn tribute to a forgotten hero and offers visitors a tranquil break from urban life."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spread across 130 acres near Katraj Lake, this zoological park combines a modern zoo, snake park, aviary, and botanical garden. It is home to species like the Bengal tiger, Indian elephant, leopard, sloth bear, and Indian cobra. The park focuses on conservation, education, and eco-awareness, offering facilities like nature trails, children’s rides, and animal adoption programs. With well-maintained paths and shaded picnic spots, it serves as an ideal family getaway just outside city limits."
  }
],

"services": [
  {
    "name": "Innova Crysta Cab Booking Pune",
    "description": "Easily book your Innova Crysta cab in Pune for a premium travel experience. Whether it’s for local city rides or long-distance trips, our seamless booking process ensures you get a comfortable and reliable vehicle with professional drivers. Perfect for families, corporate travelers, and tourists alike."
  },
  {
    "name": "Rent Innova Crysta Taxi Pune",
    "description": "Rent an Innova Crysta taxi in Pune to enjoy spacious interiors, advanced safety features, and a smooth ride. Ideal for airport transfers, outstation travel, and city tours, this SUV combines luxury with convenience, driven by experienced chauffeurs to ensure your journey is stress-free."
  },
  {
    "name": "Online Innova Crysta Cab Pune",
    "description": "Book your Innova Crysta cab online from Pune with just a few clicks. Our digital platform offers quick confirmation, multiple payment options, and flexible pickup locations, making it easier than ever to plan your travel with comfort and confidence."
  },
  {
    "name": "Affordable Innova Crysta Hire Pune",
    "description": "Get value for your money with our affordable Innova Crysta hire service in Pune. Experience the perfect blend of cost-effectiveness and luxury, whether it’s for daily commuting, family outings, or corporate travel, without compromising on vehicle quality or service standards."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune",
    "description": "Sit back and relax as our professional chauffeurs take you around Pune in a well-maintained Innova Crysta. Safety, punctuality, and courteous service are guaranteed, making your travel experience smooth and enjoyable whether it’s for business or leisure."
  },
  {
    "name": "Family Innova Crysta Taxi Pune",
    "description": "Designed with families in mind, our Innova Crysta taxis provide ample space for passengers and luggage, ensuring a comfortable ride for everyone. Perfect for family trips, airport transfers, and weekend getaways around Pune with added amenities for a pleasant journey."
  },
  {
    "name": "Corporate Innova Crysta Cab Pune",
    "description": "Elevate your corporate travel with our Innova Crysta cab service in Pune. Featuring executive seating, privacy, and professional chauffeurs, our service is tailored to meet the demands of business clients for airport transfers, client meetings, and corporate events."
  },
  {
    "name": "Airport Transfer Innova Crysta Pune",
    "description": "Ensure timely and comfortable airport transfers with our Innova Crysta taxis in Pune. Whether you’re arriving or departing, our service offers spacious seating, ample luggage room, and reliable chauffeurs to make your airport journey hassle-free."
  },
  {
    "name": "Comfortable Innova Crysta Pune",
    "description": "Travel comfortably across Pune in our well-equipped Innova Crysta vehicles. With plush interiors, climate control, and smooth suspension, our taxis are designed to provide a relaxing ride for city commutes, sightseeing, and long-distance travel."
  },
  {
    "name": "Premium Innova Crysta Car Rental Pune",
    "description": "Opt for our premium Innova Crysta rental service in Pune for a luxurious travel experience. Our fleet is regularly serviced and driven by skilled chauffeurs, ensuring high standards of comfort, cleanliness, and professionalism for all occasions."
  },
  {
    "name": "Pune Local Innova Crysta Taxi",
    "description": "Navigate Pune with ease using our local Innova Crysta taxi service. Ideal for daily errands, shopping trips, and city sightseeing, this service combines affordability with the luxury of a spacious SUV and expert drivers familiar with Pune’s routes."
  },
  {
    "name": "Outstation Innova Crysta Hire Pune",
    "description": "Plan your outstation trips with confidence by hiring our Innova Crysta in Pune. Perfect for long drives to nearby hill stations, tourist spots, and multi-day journeys, our vehicle offers excellent fuel efficiency, safety features, and comfort for all passengers."
  },
  {
    "name": "24/7 Innova Crysta Booking Pune",
    "description": "Book an Innova Crysta anytime with our 24/7 availability service in Pune. Whether it’s an early morning flight or a late-night trip, our team ensures prompt confirmations, round-the-clock customer support, and reliable vehicle dispatch for all your travel needs."
  }
],
"tableData": [
  ["Innova Crysta Cab Booking Pune", "Rent Innova Crysta Taxi Pune"],
  ["Online Innova Crysta Cab Pune", "Affordable Innova Crysta Hire Pune"],
  ["Chauffeur Driven Innova Crysta Pune", "Family Innova Crysta Taxi Pune"],
  ["Corporate Innova Crysta Cab Pune", "Airport Transfer Innova Crysta Pune"],
  ["Comfortable Innova Crysta Pune", "Premium Innova Crysta Car Rental Pune"],
  ["Pune Local Innova Crysta Taxi", "Outstation Innova Crysta Hire Pune"],
  ["24/7 Innova Crysta Booking Pune", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta Taxi Booking in Pune",
        "WhyChoosedescription": "Book our Innova Crysta cabs in Pune for a luxurious and comfortable travel experience. Whether it's for airport transfers, corporate events, family outings, or outstation trips, our Innova Crysta taxis provide ample space, superior comfort, and smooth rides."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Interiors",
        "WhyChoosedescription": "The Innova Crysta offers generous legroom, ergonomic seating, and a smooth suspension system that ensures a comfortable journey for all passengers. Perfect for families and groups, it accommodates up to 6-7 passengers with ease."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, courteous, and knowledgeable about Pune’s routes and highways. They ensure safe, timely, and hassle-free travel, enhancing your overall journey experience."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Each Innova Crysta taxi is regularly serviced and thoroughly cleaned before every trip. We prioritize hygiene and vehicle condition to provide you with a safe and pleasant travel environment."
    },
    {
        "WhyChooseheading": "Flexible Booking Options",
        "WhyChoosedescription": "Choose from hourly rentals, full-day packages, or outstation trips based on your needs. Our flexible booking system allows you to customize your itinerary, pickup, and drop locations with ease."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We offer clear and competitive pricing that includes all necessary charges such as fuel, tolls, taxes, and driver allowances. There are no surprise fees, ensuring complete peace of mind."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Book your Innova Crysta cab anytime through our user-friendly platform or by contacting our customer support team. We’re available 24/7 to assist with bookings, changes, or any special requests."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Corporate Travel, and Family Trips",
        "WhyChoosedescription": "Whether you need a reliable ride to Pune Airport, comfortable transportation for business meetings, or spacious cabs for family outings, our Innova Crysta taxis are designed to meet all your travel requirements."
    }
]

















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab in Pune?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for easy and quick booking."
    },
    {
        question: "What is the seating capacity of the Innova Crysta?",
        answer: "The Innova Crysta seats up to 6 or 7 passengers comfortably, making it ideal for families or group travel."
    },
    {
        question: "Is Innova Crysta available for local and outstation trips in Pune?",
        answer: "Yes, the Innova Crysta can be booked for both local city travel and long-distance outstation trips."
    },
    {
        question: "Are the Innova Crysta cabs sanitized before each ride?",
        answer: "Yes, all our cabs including Innova Crysta are thoroughly cleaned and sanitized before every trip."
    },
    {
        question: "Can I rent an Innova Crysta for airport transfers?",
        answer: "Yes, Innova Crysta is a popular choice for comfortable airport pickups and drop-offs."
    },
    {
        question: "What is included in the Innova Crysta cab fare?",
        answer: "The fare includes fuel, driver charges, and tolls. Parking and waiting charges may be extra if applicable."
    },
    {
        question: "Is the Innova Crysta cab service available 24/7 in Pune?",
        answer: "Yes, our Innova Crysta cab services are available 24/7 to suit your travel schedule."
    },
    {
        question: "Can I book the Innova Crysta for corporate travel or events?",
        answer: "Absolutely. We offer Innova Crysta rentals for corporate needs, events, and employee transportation."
    },
    {
        question: "Is it possible to book Innova Crysta on short notice?",
        answer: "Yes, we accept last-minute bookings depending on vehicle availability. Call us for immediate support."
    },
    {
        question: "What payment modes are accepted for Innova Crysta bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Anil Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta from Meghana Cab in Pune—very clean, spacious, and comfortable. Perfect for our family trip!”',
    },
    {
        name: 'Ms. Pooja Naik',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great experience with Meghana Cab. The Innova Crysta arrived on time and the driver was very polite.”',
    },
];






































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Innova Crysta Cabs / Taxi Booking in Pune",
  "description": "Book Innova Crysta cabs in Pune for family, corporate, airport transfers, and outstation trips. Affordable, chauffeur-driven, comfortable, and available 24/7 with online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Innova Crysta Taxi Booking",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/innova-crysta-cabs-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Innova Crysta Cabs / Taxi Booking in Pune | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Innova Crysta cabs in Pune for family, corporate, airport transfers, and outstation trips. Affordable, chauffeur-driven, comfortable, and available 24/7 with online booking." 
  />
  <meta 
    name="keywords" 
    content="Innova Crysta Cab Booking Pune, Rent Innova Crysta Taxi Pune, Online Innova Crysta Cab Pune, Affordable Innova Crysta Hire Pune, Chauffeur Driven Innova Crysta Pune, Family Innova Crysta Taxi Pune, Corporate Innova Crysta Cab Pune, Airport Transfer Innova Crysta Pune, Comfortable Innova Crysta Pune, Premium Innova Crysta Car Rental Pune, Pune Local Innova Crysta Taxi, Outstation Innova Crysta Hire Pune, 24/7 Innova Crysta Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/52.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystacabs;